import { ConstructionComponentInfo } from "@interfaces/constructor/constructor";
import GameServerChargeRate from "./gameServerChargeRate";
import GameServerContext from "./gameServerContext";
import GameServerName from "./gameServerName";
import GameServersList from "./gameServersList";

export interface GameIdProps {
    game_id?: string | number;
}

const GameServerChargeRateInfo: ConstructionComponentInfo = {
    component: GameServerChargeRate,
    props: [
        'game_id'
    ]
}

const GameServerContextInfo: ConstructionComponentInfo = {
    component: GameServerContext,
    props: [
        'game_id'
    ],
    addedChildProps: [
        'game_id'
    ]
}

const GameServerNameInfo: ConstructionComponentInfo = {
    component: GameServerName,
    props: [
        'game_id'
    ]
}

const GameServersListInfo: ConstructionComponentInfo = {
    component: GameServersList,
    props: [
        'login_id'
    ],
    addedChildProps: [
        'game_server_id',
        'game_server_name'
    ]
}

export {
    GameServerNameInfo,
    GameServerContextInfo,
    GameServerChargeRateInfo,
    GameServersListInfo
}